import { render, staticRenderFns } from "./OW.vue?vue&type=template&id=0b47a256&"
import script from "./OW.vue?vue&type=script&lang=js&"
export * from "./OW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports